import { render, staticRenderFns } from "./FormRecaptcha.vue?vue&type=template&id=6a553ab9&scoped=true"
import script from "./FormRecaptcha.js?vue&type=script&lang=js&external"
export * from "./FormRecaptcha.js?vue&type=script&lang=js&external"
import style0 from "./FormRecaptcha.vue?vue&type=style&index=0&id=6a553ab9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a553ab9",
  null
  
)

export default component.exports